<template>
  <div>
    <table class="table table-xs table-hover">

      <thead>
      <tr>
        <th colspan="7" class=" text-danger">PERSONEL BİLGİLERİ
          <button v-if="Yetki"
                  @click="this.Ekle"
                  class="el-button TableBtn el-button--success el-button--mini float-right">PERSONEL
            EKLE
          </button>
        </th>
      </tr>
      <tr>
        <th width="130">Görev <br> Maaş</th>
        <th width="500">Personel Bilgi</th>
        <th width="100">Giriş</th>
        <th width="100">Çıkış</th>
        <th width="50" v-if="Yetki"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="PersonelDetay in Liste">
        <td>
          <span><b>{{ PersonelDetay.Gorev }}</b><br></span>
          <span> <b>{{ PersonelDetay.pGun }} </b>.Gün<br></span>
          <span> <b> {{ PersonelDetay.pMaas }} TL</b><br></span>
        </td>
        <td>
          <span>Adı Soyadı: <b>{{ PersonelDetay.Unvan }}</b><br></span>
          <span>Telefon: <b>{{ PersonelDetay.Telefon }}</b><br></span>
          <span v-if="PersonelDetay.Mail">Mail: <b>{{ PersonelDetay.Mail }}</b><br></span>
          <span v-if="PersonelDetay.kIzin">Kullanılan İzin: <b>{{ PersonelDetay.kIzin }}</b> Gün<br></span>
          <span v-if="PersonelDetay.bBilgi.Adi">
              <hr class="m-1"><b>Banka Bilgi</b><br>
              <span>Banka Adı: <b>{{ PersonelDetay.bBilgi.Adi }}</b><br></span>
              <span>IBAN: <b>{{ PersonelDetay.bBilgi.Iban }}</b><br></span>
          </span>
          <span v-if="PersonelDetay.SGK.SicilNo">
                        <hr class="m-1"><b>SGK Bilgi</b><br>
                        <span>Sicil No: <b>{{ PersonelDetay.SGK.SicilNo }}</b><br></span>
                    </span>
        </td>
        <td>{{ PersonelDetay.pGirisText }}</td>
        <td>{{ PersonelDetay.pCikisText }}</td>

        <td v-if="Yetki">

          <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                      placement="top-start">
            <a href="#" @click="Duzenle(PersonelDetay)" class="text-info mr-1"> <i
              class="feather-edit-2"></i></a>
          </el-tooltip>
          <el-tooltip class="item" effect="dark"
                      :content="Sayfa.SilAdi"
                      placement="top-start">
            <a href="#" @click="SilOnay(PersonelDetay.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
          </el-tooltip>


        </td>
      </tr>
      </tbody>
    </table>
    <el-form v-if="Personel.Form" class="BilgiForm" :rules="PersonelHata" :model="Personel"
             @submit.prevent.native="PersonelKaydet"
             ref="Personel">
      <h2>{{ Personel.Baslik }} <a @click="Personel.Form=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Adı Soyadı" prop="Unvan">
            <el-input size="mini" type="input" v-model="Personel.Unvan">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Telefon" prop="Telefon">
            <el-input size="mini" v-mask="'### ### ## ##'" type="input" v-model="Personel.Telefon">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="TC Kimlik" prop="vNo">
            <el-input size="mini" v-mask="'###########'" type="input" v-model="Personel.vNo">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Mail" prop="Mail">
            <el-input size="mini" type="input" v-model="Personel.Mail">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Görev" prop="Gorev">
            <el-input size="mini" type="input" v-model="Personel.Gorev">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Maaş Günü" prop="pGun">
            <el-input-number size="mini" v-model="Personel.pGun" :min="1" :max="31"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Maaş Tutar" prop="pMaas">
            <el-input size="mini" type="input" v-model="Personel.pMaas">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">

        <el-col :span="24">
          <el-form-item label="SGK Sicil No" prop="SGK">
            <el-input size="mini" type="input" v-model="Personel.SGK.SicilNo">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Kalan İzin Günü" prop="kIzin">
            <el-input size="mini" type="input" v-model="Personel.kIzin">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Giriş Tarihi" prop="pGiris">
            <el-date-picker
              v-model="Personel.pGiris"
              type="date"
              size="mini"
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Çıkış Tarihi" prop="pCikis">
            <el-date-picker
              v-model="Personel.pCikis"
              type="date"
              size="mini"
              format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="Banka Adı" prop="bBilgi">
            <el-input size="mini" type="input" v-model="Personel.bBilgi.Adi">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="IBAN" prop="bBilgi">
            <el-input size="mini" v-mask="'TR ## #### #### #### #### #### ####'" type="input"
                      v-model="Personel.bBilgi.Iban">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>


      <button type="button" @click="PersonelKaydet"
              class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">KAYDET
      </button>

    </el-form>
  </div>
</template>


<script>
export default {
  props: {
    BinaBilgi: Object
  },
  data() {
    return {
      lo: true,
      Sayfa: {
        ButtonAdi: this.$t('eGenel.10'),
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Button: null,
        Adi: this.$t('eYonetim.20.0'),
        Menu: [],
        MenuDisplay: null,
      },
      Yetki: false,
      Liste: [],
      Personel: {
        Baslik: 'Personel Ekle',
        id: null,
        Form: false,
        Gorev: null,
        Unvan: null,
        Telefon: null,
        Mail: null,
        pGiris: null,
        pCikis: null,
        pGun: null,
        kIzin: null,
        pMaas: null,
        vNo: null,
        Bina_id: this.BinaBilgi.id,
        bBilgi: {
          Adi: null,
          Iban: null,
        },
        SGK: {
          SicilNo: null,
        }
      },
      PersonelHata: {
        Gorev: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Unvan: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Telefon: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        pGiris: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        vNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      }

    }
  },
  methods: {
    PersonelKaydet() {
      this.$refs['Personel'].validate((valid) => {
        if (valid) {
          if (this.Personel.id) {
            // DÜZENLE
            this.$store.dispatch("Put", {
              ...this.Personel,
              path: 'muhasebe/cari/' + this.Personel.id
            })
              .then(response => {
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                  this.SayfaYukle();
                  this.Personel = {
                    Baslik: 'Personel Ekle',
                    id: null,
                    Form: false,
                    Gorev: null,
                    Unvan: null,
                    Telefon: null,
                    Mail: null,
                    pGiris: null,
                    pCikis: null,
                    pGun: null,
                    pMaas: null,
                    kIzin: null,
                    vNo: null,
                    Bina_id: this.BinaBilgi.id,
                    bBilgi: {
                      Adi: null,
                      Iban: null,
                    },
                    SGK: {
                      SicilNo: null,
                    }
                  }

                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })

          } else {
            // EKLE
            this.$store.dispatch("Post", {
              ...this.Personel,
              path: 'muhasebe/cari'
            })
              .then(response => {
                if (response.Durum == "OK") {
                  this.SayfaYukle();
                  this.$message.success(response.Mesaj);
                  this.Personel = {
                    Baslik: 'Personel Ekle',
                    id: null,
                    Form: false,
                    Gorev: null,
                    Unvan: null,
                    Telefon: null,
                    Mail: null,
                    pGiris: null,
                    pCikis: null,
                    pGun: null,
                    pMaas: null,
                    vNo: null,
                    kIzin: null,
                    Bina_id: this.BinaBilgi.id,
                    bBilgi: {
                      Adi: null,
                      Iban: null,
                    },
                    SGK: {
                      SicilNo: null,
                    }
                  }
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        }
      });
    },
    SayfaYukle() {
      if (this.BinaBilgi.id) {
        this.$store.dispatch("Get", {path: 'muhasebe/cari/b/' + this.BinaBilgi.id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.lo = false
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }

      this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
    },
    Ekle() {
      this.Personel = {
        Baslik: 'Personel Ekle',
        id: null,
        Form: true,
        Gorev: null,
        Unvan: null,
        Telefon: null,
        Mail: null,
        pGiris: null,
        pCikis: null,
        pGun: null,
        pMaas: null,
        vNo: null,
        kIzin: null,
        Bina_id: this.BinaBilgi.id,
        bBilgi: {
          Adi: null,
          Iban: null,
        },
        SGK: {
          SicilNo: null,
        }
      }
    },
    Duzenle(Veri) {
      this.Personel = {
        Baslik: 'Personel Düzenle',
        id: Veri.id,
        Form: true,
        Gorev: Veri.Gorev,
        Unvan: Veri.Unvan,
        Telefon: Veri.Telefon,
        Mail: Veri.Mail,
        pGiris: Veri.pGiris,
        pCikis: Veri.pCikis,
        pGun: Veri.pGun,
        pMaas: Veri.pMaas,
        vNo: Veri.vNo,
        kIzin: Veri.kIzin,
        Bina_id: this.BinaBilgi.id,
        bBilgi: {
          Adi: Veri.bBilgi.Adi,
          Iban: Veri.bBilgi.Iban
        },
        SGK: {
          SicilNo: Veri.SGK.SicilNo
        }
      };

    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'muhasebe/cari/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },

  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/Personel.vue